import React from "react";
import { withNavBars } from "../../HOCs";
import LeaseAndSalesManagerDashboard from "./leaseandsalesmanagerdashboard";
class LeaseManagerDashboardParent extends React.Component {
  render() {
    return (
      <LeaseAndSalesManagerDashboard {...this.props} />
    );
  }
}
const props = {
  boxShadow: false
}
export default withNavBars(LeaseManagerDashboardParent, props);